import { Button, Col, Form, Row, Space, theme, Table, DatePicker, Select, Card, Progress, Tag, List, Typography, Image, Input, InputNumber } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import dayjs from 'dayjs';
import { filterOption, filterShopsByUser } from '../../utils/funcHelper';
import { requiredItem } from '../../constants/constants';
import { getListShops, getOrdersReport, getTop10BestSellers } from '../../services/apis';
import { useSelector } from 'react-redux';

const ReportTop10SellerPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [dataTopSeller, setDataTopSeller] = useState([]);
    const [loading, setLoading] = useState(false);
    const { RangePicker } = DatePicker;
    const [dataShops, setDataShops] = useState([]);
    const [top_keywords, setTop_keywords] = useState([]);
    const userReducer = useSelector(state => state?.userReducer?.data);
    const [top, setTop] = useState(10);
    const { Text } = Typography;
    const columns = [
        {
            title: 'Rank',
            dataIndex: 'rank',
            key: 'rank',
            width: 50,
            align: 'center',
            render: (text, record, index) => <div>{text}</div>
        },
        {
            title: 'Ảnh',
            dataIndex: 'sku_image',
            key: 'sku_image',
            render: (text, record) => <div style={{padding: 8}}>
                <Image src={text} alt="sku" style={{ width: 50, height: 50, objectFit: 'cover' }} />
            </div> 
        },
        {
            title: 'Tên sản phẩm',
            dataIndex: 'product_name',
            key: 'product_name',
            width: 150,
            render: (text, record) => <div style={{fontWeight: '700' }}>{text}</div>
        },
        {
            title: 'Số lượng',
            dataIndex: 'total_quantity',
            key: 'total_quantity',
            align: 'center',
            render: (text, record) => <div style={{fontWeight: '400' }}>{text}</div>
        },
        {
            title: 'Shop',
            dataIndex: 'shop_name',
            key: 'shop_name',
            render: (text, record) => <div style={{fontWeight: '400', paddingLeft: 12 }}>{record?.custom_code} - {text}</div>
        },
        {
            title: 'Category',
            dataIndex: 'category_lv3',
            key: 'category_lv3',
            render: (text, record) => <div style={{fontWeight: '400', paddingLeft: 12 }}>{text ?? ''}</div>
        }
        
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    // Tính max để scale Progress
    const maxKeywordCount = Math.max(1, ...top_keywords.map(k => Number(k?.count) || 0));
    const numbSlice = top_keywords.length > top ? top : 10;
    const keywordsData = (top_keywords || [])
                        .slice()
                        .sort((a, b) => (Number(b?.count) || 0) - (Number(a?.count) || 0))
                        .slice(0, numbSlice);

    const getDataReport = async (startTime, endTime) => {
        const params = {
            shop_ids: form.getFieldValue('shop_ids') || [],
            from_date: startTime,
            to_date: endTime,
            user_id: userReducer?.user_info?.id,
            top: top,
        }
        setLoading(true);
        const res = await getTop10BestSellers(params);
        consoleLogUtil('getTop10BestSellers', res);
        setLoading(false);
        if (res && res.status === 1) {
            setDataTopSeller([...res?.data?.data || []]);
            setTop_keywords([...res?.data?.keyword_analysis?.top_keywords || []]);
        } else {
            setDataTopSeller([]);
            setTop_keywords([]);
        }
    }
    const getDataShops = async () => {
        try {
            const res = await getListShops();
            consoleLogUtil('getListShops', res);
            if (res && res.status === 1) {
                const lstShop = res?.data?.data || [];
                const filterShops = filterShopsByUser(lstShop, userReducer);
                setDataShops([...filterShops?.map((item, index) => ({ ...item, value: item?.shop_id, label: `${index + 1}. ${item?.shop_name}` })) || []]);
            } else {
                setDataShops([]);
            }
        } catch (error) {
            setDataShops([]);
        }
    }

    const onFinish = async (dataForm) => {
        if (dataForm && dataForm?.date) {
            getDataReport(dayjs(dataForm.date[0]).format("YYYY-MM-DD HH:mm:ss"), dayjs(dataForm.date[1]).format("YYYY-MM-DD HH:mm:ss"))
        } else {
            getDataReport(dayjs().format("YYYY-MM-DD") + "00:00:00", dayjs().format("YYYY-MM-DD HH:mm:ss"))
        }
    };
    

    useEffect(() => {
        getDataShops();
    }, []);
    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={4}>
                    <Form.Item
                        name={'top'}
                    >
                        <Select 
                            placeholder={'Chọn Top'}
                            style={{ width: '100%', height: 40 }}
                            defaultValue={10}
                            onChange={(value) => setTop(value)}
                            options={[
                                { value: 5, label: 'Top 5' },
                                { value: 10, label: 'Top 10' },
                                { value: 20, label: 'Top 20' },
                                { value: 25, label: 'Top 25' },
                                { value: 30, label: 'Top 30' },
                                { value: 50, label: 'Top 50' },
                                { value: 100, label: 'Top 100' },
                            ]}
                        />
                    </Form.Item>
                        
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name={'shop_ids'}
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn  shop'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataShops}
                                mode='multiple'
                                maxTagCount={'responsive'}
                            />
                        </Form.Item>
                    </Col>
                    
                    <Col span={10}>
                        <Form.Item
                            name={'date'}
                            rules={requiredItem}
                        >
                            <RangePicker
                                style={{ height: 40, width: '100%' }}
                                format="YYYY-MM-DD HH:mm:ss"
                                showTime
                                allowClear={false}
                            />
                        </Form.Item>
                    </Col>


                    <Col span={2}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit">
                                Tìm kiếm
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            {/* Layout 2 cột: Trái 70% (bảng), Phải 30% (keywords) */}
            <Row gutter={16}>
                <Col xs={24} lg={17}>
                    <Card size="small" title="Top 10 Best Sellers" style={{ marginBottom: 16 }}>
                        <Table
                            className='table-book'
                            columns={columns}
                            dataSource={dataTopSeller}
                            pagination={false}
                            rowKey={(record) => record?.id}
                            scroll={{ x: 'max-content' }}
                        />
                    </Card>
                </Col>

                <Col xs={24} lg={7}>
                    <Card size="small" title="Top 10 Keywords" style={{ marginBottom: 16 }}>
                        <List
                            dataSource={keywordsData}
                            locale={{ emptyText: 'No keywords' }}
                            renderItem={(item, index) => (
                                <List.Item style={{ padding: '8px 0' }}>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Tag color="blue" style={{ maxWidth: '70%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {item?.keyword}
                                            </Tag>
                                            <Text type="secondary">x{item?.count ?? 0}</Text>
                                        </div>
                                        <Progress
                                            percent={Math.round(((Number(item?.count) || 0) / maxKeywordCount) * 100)}
                                            showInfo={false}
                                            size="small"
                                            strokeColor="#1677ff"
                                        />
                                    </div>
                                </List.Item>
                            )}
                        />
                    </Card>
                </Col>
            </Row>
            
            <LoadingBase loading={loading} />

        </div>
    )
}
export default React.memo(ReportTop10SellerPage);